extraRootIds